import React, { useState } from "react";
import { useTranslation } from "react-i18next";

type TruncatedTextProps = {
  text: string;
  numberOfWords: number;
};

const SeeMoreText: React.FC<TruncatedTextProps> = ({
  text,
  numberOfWords,
}) => {
  const [showFullText, setShowFullText] = useState(false);
  const {t} = useTranslation();
  const showText = t("SubTotalComponent.readMore");
  const hideText = t("SubTotalComponent.readLess");
  const isLongText = text.length > numberOfWords;

  const displayedText =
    showFullText || !isLongText
      ? text
      : text.slice(0, numberOfWords) + "...";

  const toggleShowFullText = () => {
    setShowFullText(!showFullText);
  };

  return (
    <div className="text-sm text-center mt-3 mb-1">
      <p className="break-words">
        {displayedText}
      </p>
      {isLongText ? (
        <button className="font-medium cursor-pointer" onClick={toggleShowFullText}>
          <p className="underline">{showFullText ? hideText : showText}</p>
        </button>
      ) : null}
    </div>
  );
};

export default SeeMoreText;